import React, { createContext, useContext, useEffect, useState } from "react";

const ProjectCategoryContext = createContext();

export const ProjectCategoryProvider = ({ children }) => {
  const [projectCategory, setProjectCategory] = useState(() => {
    const cat = localStorage.getItem("project_category");
    return cat ? cat.replace(/^"|"$/g, '') : null;
  });

 useEffect(() => {
    const handler = () => {
        const cat = localStorage.getItem("project_category");
        setProjectCategory(cat ? cat.replace(/^"|"$/g, '') : null);  
    };
    window.addEventListener("projectCategoryChanged", handler);
    window.addEventListener("storage", handler);
    return () => {
        window.removeEventListener("projectCategoryChanged", handler);
        window.removeEventListener("storage", handler);
    };
}, []);

  return (
    <ProjectCategoryContext.Provider value={{ projectCategory }}>
      {children}
    </ProjectCategoryContext.Provider>
  );
};

export const useProjectCategory = () => useContext(ProjectCategoryContext);
